import {Component, OnInit} from '@angular/core';
import {TopManagementService} from '../_services/top-management.service';
import {ViewManagementModel} from '../_models/viewManagement.model';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-view-tm-post',
    templateUrl: './view-tm-post.component.html',
    styleUrls: ['./view-tm-post.component.scss']
})

export class ViewTmPostComponent implements OnInit {
    constructor(private topManagementService: TopManagementService, private snackBar: MatSnackBar, private route: ActivatedRoute) {
    }

    postData: ViewManagementModel;
    isLoaded: boolean;
    postId: string;

    consentResponse: boolean;
    checkIfUserConsent: boolean;

    ngOnInit() {
        this.route.params.subscribe((res: any) => {
            this.postId = res.id;
            this.checkUserConsent(this.postId);
            this.topManagementService.viewTopManagement(this.postId).subscribe((post: any) => {
                this.postData = post;
                this.isLoaded = true;
            })
        })
    }

    userGiveConsent() {
        this.topManagementService.userConsent(this.postId, this.consentResponse).subscribe((resp) => {
            this.openNotification('Ai luat la cunostinta!');
            location.reload();
        })
    }

    checkUserConsent(postId) {
        this.topManagementService.checkIfUserConsent(postId).subscribe((resp: any) => {
            this.checkIfUserConsent = resp.success;
        })
    }

    openNotification(message) {
        this.snackBar.open(message, 'Inchide', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
        });
    }
}
